import React from 'react';
import { translate } from 'react-i18next';

/**
 * feature/acceso-subcompanias: the user has a list of subcompanies and none of
 * them is (still) live in the company. The back answers the list empty and 403
 * on every route of a subcompany; an Administrador fixes it in Users.
 */
export const NoSubcompanies = ({ t = (k) => k }) => (
  <div className="col-12 mt-4">
    <div className="alert alert-warning" role="alert">
      {t('subcompanies.none_assigned')}
    </div>
  </div>
);

export default translate()(NoSubcompanies);



// WEBPACK FOOTER //
// src/components/layout/NoSubcompanies.js